import { render, staticRenderFns } from "./AeMenu.vue?vue&type=template&id=2fb52875&scoped=true"
import script from "./AeMenu.vue?vue&type=script&lang=js"
export * from "./AeMenu.vue?vue&type=script&lang=js"
import style0 from "./AeMenu.vue?vue&type=style&index=0&id=2fb52875&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb52875",
  null
  
)

export default component.exports